import { ADMIN_ACTION_SOURCES } from '../../constants/adminNav.js';

/**
 * KPI presentation only. Counts still come from getAdminDashboardSummary.kpis.
 * This is not a second Action Center registry.
 */
export const ADMIN_KPI_CARD_DEFS = [
  {
    id: 'rentalyzer-users',
    valueKey: 'rentalyzerUsers',
    titleKey: 'admin.home.kpi.rentalyzerUsers',
    hintKey: 'admin.home.kpi.rentalyzerUsers.hint',
    href: '/admin/users',
  },
  {
    id: 'pending-approvals',
    valueKey: 'pendingApprovals',
    titleKey: 'admin.nav.approvals',
    href: '/admin/approvals',
  },
  {
    id: 'new-feedback',
    valueKey: 'newFeedback',
    titleKey: 'admin.nav.feedback',
    href: '/admin/feedback',
  },
];

/**
 * @param {object | null | undefined} actions
 * @param {string} countKey
 * @returns {number | null}
 */
export function readDashboardActionCount(actions, countKey) {
  if (!actions || typeof actions !== 'object') return null;
  const value = actions[countKey];
  if (typeof value !== 'number' || !Number.isFinite(value)) return null;
  return value;
}

/**
 * Assemble ADMIN_ACTION_SOURCES with summary.actions for the current role.
 * count === 0 items are omitted. Missing/non-numeric counts are omitted (never coerced to 0).
 *
 * @param {{
 *   sources?: typeof ADMIN_ACTION_SOURCES,
 *   actions?: object | null,
 *   role?: string | null,
 * }} [params]
 */
export function visibleAdminInboxItems({
  sources = ADMIN_ACTION_SOURCES,
  actions,
  role,
} = {}) {
  if (!role) return [];
  const items = [];
  for (const source of sources) {
    if (!Array.isArray(source.allowedRoles) || !source.allowedRoles.includes(role)) continue;
    const count = readDashboardActionCount(actions, source.countKey);
    if (count == null || count <= 0) continue;
    items.push({ ...source, count });
  }
  return items;
}
